import CurrentZoneIndicator from './CurrentZoneIndicator';

export default CurrentZoneIndicator;
